import {KeycloakTokenParsed} from "keycloak-js";

export interface Principal {
  sub: string | undefined,
  token: string | undefined,
  refreshToken: string | undefined,
  parsedToken: KeycloakTokenParsed
}
